import {instance, IResponse} from "@shared/api/axiosInstance";
import {IResponseUserData} from "../../features/auth/authStore";


export const sessionAPI = {
    authMe() {
        return instance.get<IResponse<IResponseUserData>>(`auth/me`).then(res => res.data)
    },
    logout() {
        return instance.get<IResponse<IResponseUserData>>(`auth/logout`).then(res => res.data)
    },
}